import React, { useReducer, useContext } from 'react'
import OutletForm from './OutletForm';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import AuthContext from '../../context/auth-context'
import validate from 'validate.js';
import listPropinsi from '../Constants/Province';
import Kota from '../Constants/Kota'
import GQL from '../../GQL';
const { listKotaCheck } = Kota;

const initialValue = {
  data: {
    kodeoutlet: '',
    namaoutlet: '',
    database: '',
    userdb: '',
    pwddb: '',
    tax: 0,
    service: 0,
    fullName: '',
    email: '',
    phoneNumber: '',
    address: '',
    country: 'IDN',
    province: '',
    city: '',
    zipCode: '',
    isTrialMode: false,
    trialKategori: 2,
    trialSubKategori: 20,
    trialBarang: 50,
    trialTransaksiPerDay: 20,
    connectHoman: false,
    mysqlHost: '',
    mysqlDb: '',
    mysqlUser: '',
    mysqlPwd: '',
    salesreferencecode: '',
    jumlahdevice: 1,
    usePassti: false,
    useCashlez: false,
    useQREN: false,
    isOpname: false,
    useIposStock: false,
    usePoktan: false,
    server: 'ALL'
  },
  isSaving: false,
  error: null
}

const reducer = (state, action) => {
  switch (action.type) {
    case "UPDATE":
      return {
        ...state,
        data: action.data
      }
    case "SAVING":
      return {
        ...state,
        isSaving: true,
        error: null
      }
    case "SAVED":
      return {
        ...state,
        isSaving: false
      }
    case 'ERROR':
      return {
        ...state,
        isSaving: false,
        error: action.error
      }
    default: return state;
  }
}

const AddOutlet = (props) => {

  const [state, dispatch] = useReducer(reducer, initialValue)
  const { clientID, token } = useContext(AuthContext)

  const handleChange = (key, value) => {
    const newState = Object.assign({}, state.data);
    newState[key] = value;
    dispatch({ type: "UPDATE", data: newState })
  }

  const validateForm = () => {
    const promNamaOutlet = new Promise((resolve, reject) => {
      const myFormat = /^(\+62|\+0|0|62)8(1[123]|52|51|53|21|22|23)[0-9]{5,9}$|^(\+62815|0815|62815|\+0815|\+62816|0816|62816|\+0816|\+62858|0858|62858|\+0814|\+62814|0814|62814|\+0814)[0-9]{5,9}$|^(\+62855|0855|62855|\+0855|\+62856|0856|62856|\+0856|\+62857|0857|62857|\+0857)[0-9]{5,9}$|^(\+62817|0817|62817|\+0817|\+62818|0818|62818|\+0818|\+62819|0819|62819|\+0819|\+62859|0859|62859|\+0859|\+0878|\+62878|0627|0629|06410642|0643|0644|0645|0646|0650|0651|0652|0653|0654|0655|0656|0657|0658|0659|061|0620|0621|0622|0623|0624|0625|0626|0627|0628|0630|0631|0632|0633|0634|0635|0636|0639|0751|0752|0753|0754|0755|0756|0757|0759|0760|0761|0762|0763|0764|0765|0766|0767|0768|0769|0624|0770|0771|0772|0773|0776|0777|0778|0779|0740|0741|0742|0743|0744|0745|0746|0747|0748|0702|0711|0712|0713|0714|0730|0731|0733|0734|0735|0715|0716|0717|0718|0719|0732|0736|0737|0738|0739|0721|0722|0723|0724|0725|0726|0727|0728|0729|021|0252|0253|0254|0257|022|0231|0232|0233|0234|0251|0260|0261|0262|0263|0264|0265|0266|0267|0274|024|0271|0272|0273|0274|0275|0276|0280|0281|0282|0283|0284|0285|0286|0287|0289|0291|0292|0293|0294|295|0296|0297|0298|0299|0356|031|0321|0322|0323|0324|0325|0327|0328|0331|0332|0333|0334|0335|0336|0338|0341|0342|0343|0351|0352|0353|0354|0355|0356|0357|0358|0361|0362|0363|0365|0366|0368| 0364|0370|0371|0372|0373|0374|0376|0380|0381|0382|0383|0384|0385|0386|0387|0388|0389|0561|0562|0563|0564|0565|0567|0568|0534|0513|0522|0525|0526|0528|0531|0532|0536|0537|0538|0539|0511|0512|0517|0518|0526|0527|0541|0542|0543|0545|0548|0549|0554|0551|0552|0553|0556|0430|0431|0432|0434|0438|0435|0443|0445|0450|0451|0452|0453|0454|0457|0458|0461|0462|0463|0464|0465|0455|0422|0426|0428|0410|0411|0413|0414|0417|0418|0419|0420|0421|0423|0427|0471|0472|0473|0474|0475|0481|0482|0484|0485|0401|0402|0403|0404|0405|0408|0910|0911|0913|0914|0915|0916|0917|0918|0921|0922|0923|0924|0927|0929|0931|0901|0902|0951|0952|0955|0956|0957|0966|0967|0969|0971|0975|0980|0981|0983|0984|0985|0986|0878|62878|\+0877|\+62877|0877|62877)[0-9]{5,9}$|^(\+62|\+0|0|62)8(28)[0-9]{5,9}$|^(\+62|\+0|0|62)8(3[128])[0-9]{5,9}$|^(\+62|\+0|0|62)8(8[1278])[0-9]{5,9}$|^(\+62|\+0|0|62)8(9[678])[0-9]{5,9}$/g;
      const constraint = {
        namaoutlet: {
          length: {
            minimum: 3,
            message: "Nama outlet minimal terdiri dari 3 huruf"
          },
        }, fullName: {
          length: {
            minimum: 3,
            message: "Nama minimal terdiri dari 3 huruf"
          }
        }, email: {
          email: {
            message: "Email tidak valid"
          }
        }, address: {
          length: {
            miminum: 10,
            message: "Alamat terlalu pendek. Harap mengisi alamat lengkap"
          }
        },
        phoneNumber: {
          length: {
            minimum: 9,
            message: "Nomor Handphone terlalu pendek"
          },
          // format: {
          //   pattern: myFormat,
          //   message: "Nomor Handphone tidak sesuai dengan format operator Indonesia."
          // }
        },
        country: {
          inclusion: {
            within: ["IDN"],
            message: "Harap memilih negara yang valid"
          }
        },
        province: {
          inclusion: {
            within: listPropinsi,
            message: "Harap memilih propinsi yang valid"
          }
        },
        city: {
          inclusion: {
            within: listKotaCheck,
            message: "Harap memilih kota yang valid"
          }
        },
        zipCode: {
          length: {
            is: 5,
            message: "Harap mengisi kode pos dengan format yang sesuai"
          },
          format: {
            pattern: "[0-9]+",
            message: "Mohon mengisi kode pos dengan nomor saja"
          }
        },
        tax: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "Harap mengisi persentase pajak yang sesuai"
          }
        },
        service: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "Harap mengisi persentase service yang sesuai"
          }
        }
      }
      const validator = validate(state.data, constraint, { fullMessages: false });
      console.log(validator);
      if (validator === undefined) {
        resolve();
      } else {
        reject(validator);
      }
    })
    return Promise.all([promNamaOutlet]);
  }

  const handleSimpan = () => {
    validateForm().then(() => {
      dispatch({ type: "SAVING" });
      const { namaoutlet, fullName, email, phoneNumber, address, city, country, zipCode, tax, service, isTrialMode, connectHoman, province, salesreferencecode, isOpname, useQREN, useIposStock, usePoktan, server} = state.data;
      const myHeader = new Headers();
      myHeader.append("Accept", "application/json");
      myHeader.append("Content-Type", "application/json");
      myHeader.append("X-API-CLIENT-ID", clientID);
      myHeader.append("X-API-TOKEN", token);
      const myInit = {
        method: "POST",
        headers: myHeader,
        body: JSON.stringify({ namaoutlet, fullName, email, phoneNumber, address, city, country, zipCode, tax, service, isTrialMode, connectHoman, province, salesreferencecode })
      }
      const query = `
              mutation{
                simpanOutlet(
                  input:{
                    namaoutlet:"${namaoutlet}",
                    fullName:"${fullName}",
                    email:"${email}",
                    phoneNumber:"${phoneNumber}",
                    address:"${address}",
                    city:"${city}",
                    country:"${country}",
                    zipCode:"${zipCode}",
                    tax:${tax},
                    service:${service},
                    isTrialMode:${isTrialMode},
                    connectHoman:${connectHoman},
                    province:"${province}",
                    salesreferencecode:"${salesreferencecode}",
                    isOpname: ${isOpname},
                    useQREN:${useQREN},
                    useIposStock:${useIposStock},
                    usePoktan:${usePoktan},
                    serverOutlet: "${server}"
                  }
                )
              }
            `
      GQL(query, clientID, token).then(resp => {
        if (resp.errors) throw resp.errors;
        if (resp.data.simpanOutlet) {
          dispatch({ type: "SAVED" });
          alert("Outlet berhasil diregistrasi");
          props.history.push(`/outlet/1/5`);
        }
      }).catch(err => {
        if (Array.isArray(err)) {
          if (err.length > 0) {
            if (err[0].message === "Data Tidak Ditemukan") return (dispatch({ type: "NODATA" }));
          }
        }
        dispatch({ type: "FAILED", error: err });
      })
    }).catch(err => {
      const keys = Object.keys(err);
      var errorMessage = "";
      for (const key of keys) {
        errorMessage += err[key] + "\n";
      }
      // console.log(err);
      alert(errorMessage);
    })

  }

  if (state.isSaving) return (<Spinner animation="border" role="status" className="spinner">
    <span className="sr-only">Loading...</span>
  </Spinner>)
  return (
    <Container>
      <OutletForm data={state.data} handleChange={handleChange} />

      <Row style={{ marginTop: 20, marginBottom: 20 }}>
        <Col xs={12} className="text-center">
          <Button variant="contained" color="primary" onClick={handleSimpan}>Simpan</Button>
        </Col>
      </Row>
    </Container>
  )
}

export default AddOutlet;